import SEO from "@/components/SEO";
import CTABanner from "@/components/CTABanner";
import ProjectCard from "@/components/ProjectCard";
import { projects } from "@/data/projects";

export default function Projects() {
  return (
    <>
      <SEO
        title="Projects | Yaduraj Enterprises"
        description="Selected solar, BESS, switchyard, SVG and piling projects executed by Yaduraj Enterprises across Rajasthan and India."
      />
      <section className="ye-page-hero">
        <div className="ye-container">
          <span className="ye-eyebrow">Projects</span>
          <h1 className="ye-display ye-h1" style={{ margin: "8px 0 18px" }}>Work That Held Its Schedule</h1>
          <p style={{ maxWidth: 880, fontSize: 17, color: "rgba(255,255,255,0.9)" }}>
            Selected projects across solar, storage, electrical and civil scopes. Detailed references and client contacts are shared on request.
          </p>
        </div>
      </section>

      <section className="ye-section">
        <div className="ye-container ye-grid-3" style={{ gap: 28 }}>
          {projects.map((p) => <ProjectCard key={p.slug} project={p} />)}
        </div>
      </section>

      <CTABanner />
    </>
  );
}
